import { Fragment, useContext } from "react";

import AuthContext from "context/auth/authContext";
import { COMPANY_COLUMNS } from "shared/constants/columns";
import {
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS
} from "shared/types/enums";

import EditCompanyInline from "../Actions/dialogs/Companies/Inline/EditCompany";
import { useCompanyInlineActions } from "../Actions/InlineActions";
import MainContainer from "../MainContainer";
import Table from "../Table";

const Companies = () => {
    const { isSupportUser } = useContext(AuthContext);

    const { inlineActions, rowData, isOpen, closeDialog } =
        useCompanyInlineActions();

    return (
        <Fragment>
            <MainContainer>
                <Table
                    name={TABLE_NAMES.Companies}
                    nameForFilters={TABLE_NAMES_WITH_FILTERS.Companies}
                    initialColumns={COMPANY_COLUMNS}
                    inlineActions={inlineActions}
                    idType={ID_TYPE.Id}
                    hideFilters={!isSupportUser}
                    hasActionBar
                    hasDetails
                />
            </MainContainer>

            <EditCompanyInline
                data={rowData}
                isOpen={isOpen}
                close={closeDialog}
            />
        </Fragment>
    );
};

export default Companies;
